import { render, staticRenderFns } from "./CurrentUser.vue?vue&type=template&id=24590a07&scoped=true&lang=pug&"
import script from "./CurrentUser.vue?vue&type=script&lang=js&"
export * from "./CurrentUser.vue?vue&type=script&lang=js&"
import style0 from "./CurrentUser.vue?vue&type=style&index=0&id=24590a07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24590a07",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24590a07')) {
      api.createRecord('24590a07', component.options)
    } else {
      api.reload('24590a07', component.options)
    }
    module.hot.accept("./CurrentUser.vue?vue&type=template&id=24590a07&scoped=true&lang=pug&", function () {
      api.rerender('24590a07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/virtualrowFSFB/CurrentUser.vue"
export default component.exports